import React from 'react'
import LicenseCertificateList from '../../components/licensecertificatedetailscomponents/LicenseCertificateList';

function LicenseCertificateListPage({ renderPageContent }) {
    return (
        <>
            {/*Dynamic content goes here */}
            <LicenseCertificateList renderPageContent={renderPageContent} />


        </>
    )
}

export default LicenseCertificateListPage;